// Persistent, browser-generated device identifier for this client.
//
// The backend treats "device" as an opaque client-supplied string (mobile apps already send
// one); there is no hardware id for a browser, so we generate a random id once and persist it
// in localStorage. Clearing storage (or a new browser/profile) intentionally looks like a new
// device to the backend, requiring re-login - this mirrors a mobile app reinstall.
export const DEVICE_ID_STORAGE_KEY = "sia_device_id";

function generateId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  // Fallback UUID v4 for browsers without crypto.randomUUID (non-secure contexts, older browsers).
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getOrCreateDeviceId() {
  const existing = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
  if (existing) {
    return existing;
  }
  const id = generateId();
  localStorage.setItem(DEVICE_ID_STORAGE_KEY, id);
  return id;
}
